'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateResourceSummary = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import 'moment-timezone';

// let moment = require('moment-timezone/moment-timezone');
var moment = void 0;
if (_momentTimezone2.default.default) {
  moment = _momentTimezone2.default.default;
} else {
  moment = _momentTimezone2.default;
}

console.log('moment', moment);

// // if (!moment) {
// //   var moment = require('moment-timezone');
// // }
//
// // import 'moment';
// import moment from 'moment-timezone';
//
// // console.log('moment', moment);

var calculateResourceSummary = function calculateResourceSummary(job) {
  var timezone = job.timezone || 'America/Los_Angeles';

  var baseDates = {};

  var d = moment(job.start).tz(timezone).startOf('d');
  while (moment(d).isSameOrBefore(moment(job.end))) {
    baseDates[d.format('Y-MM-DD')] = {
      resources: {
        requested: 0,
        allocated: 0
      }
    };
    d.add(1, 'days');
  }

  var dates = _lodash2.default.values(job.resources).reduce(function (res, val) {
    var date = moment(val.from).tz(timezone).startOf('day').format('Y-MM-DD');
    if (!(date in res)) {
      res[date] = {
        resources: {
          requested: 0,
          allocated: 0
        }
      };
    }

    res[date].resources.requested += 1;
    if (val.employeeId) {
      res[date].resources.allocated += 1;
    }

    return res;
  }, baseDates);

  return dates;
};

exports.calculateResourceSummary = calculateResourceSummary;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sakari-io/staza-common/dist/jobs.js
// module id = 1154
// module chunks = 0